<app-modal-filler-atom
  (click)="close()"
  [index]="index()"
></app-modal-filler-atom>
<div
  class="fixed bottom-0 left-0 right-0 mx-auto flex w-full max-w-screen-sm justify-center md:bottom-auto md:top-0 md:h-full md:max-w-none md:items-center kiosk:bottom-auto kiosk:top-0 kiosk:h-full kiosk:max-w-none kiosk:items-center"
  role="dialog"
  aria-modal="true"
  aria-labelledby="unavailable-product-modal-title"
  [style.z-index]="750"
  [style.bottom.px]="keyboardOffset"
  [class.bottom-0]="keyboardOffset === 0"
>
  <div
    class="flex max-h-85-screen w-full max-w-screen-sm flex-col overflow-hidden rounded-t-3xl bg-white md:rounded-3xl md:min-w-448 kiosk:rounded-3xl kiosk:min-w-448"
    [style.z-index]="index() + 50"
  >
    <div class="overflow-y-auto px-5 pt-5">
      <div class="flex items-start justify-between gap-4">
        <h1
          id="unavailable-product-modal-title"
          class="font-brand text-2xl font-bold text-neutral-800 kiosk:text-4xl"
        >
          {{ 'unavailable-product-modal.title' | translate }}
        </h1>
        <app-rounded-icon-button
          icon="icon-cross"
          (onClick)="close()"
        ></app-rounded-icon-button>
      </div>

      <p class="pb-6 pt-4 font-base text-base text-neutral-800 kiosk:text-2xl">
        {{ 'unavailable-product-modal.message' | translate }}
      </p>

      <div class="flex flex-col gap-3 pb-6">
        @for (product of cards(); track product.id) {
          <div class="flex items-center gap-4 rounded-2xl border border-neutral-200 p-3">
            <div
              class="h-16 w-16 shrink-0 overflow-hidden rounded-xl bg-neutral-100 kiosk:h-24 kiosk:w-24"
            >
              @if (product.imageUrl) {
                <img
                  class="h-full w-full object-cover"
                  [src]="product.imageUrl"
                  [alt]="product.name"
                />
              }
            </div>
            <div class="min-w-0">
              <p class="font-accent text-base font-semibold text-neutral-800 kiosk:text-2xl">
                {{ product.name }}
              </p>
              <div class="mt-2">
                <app-tag-atom
                  color="error"
                  size="S"
                  [text]="'unavailable-product-modal.unavailable' | translate"
                ></app-tag-atom>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <footer
      class="shrink-0 border-t border-neutral-100 px-5 pb-5 pt-4"
      [class.pb-8]="isNotched()"
    >
      <app-button-atom
        [full]="true"
        size="L"
        [type]="isKiosk() ? 'kiosk-primary' : 'primary'"
        [label]="'unavailable-product-modal.acknowledge' | translate"
        (clickEventEmitter)="close()"
      ></app-button-atom>
    </footer>
  </div>
</div>
